import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';
import * as moment from 'moment';

@Pipe({
  name: 'dateTransform',
})
export class DateTransformPipe extends DatePipe implements PipeTransform {

  // @ts-ignore
  transform(date: string, format: string = 'DD.MM.YYYY'): string {
    if (date) {
      return moment(date).format(format);
    }
  }

}
